import { Controller } from "@hotwired/stimulus"

// Opens and closes the <dialog> it wraps; nothing else.
export default class extends Controller {
  static targets = ["dialog"]

  open(event) {
    event?.preventDefault()
    this.dialogTarget.showModal?.()
  }

  close(event) {
    event?.preventDefault()
    this.dialogTarget.close?.()
  }
}
